//
//
//
//
//
//
//
//
//
//
//
//

import RoleList from "@/components/Query/RoleList";
export default {
  name: "Role",
  data() {
    return {};
  },
  components: { RoleList },
  filters: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
